const initCookiePopup = () => {
  const popup = document.querySelector('[data-cookie-popup]');
  const acceptButton = document.querySelector('[data-cookie-accept]');
  
  if (!popup || !acceptButton) return;
  
  // Проверяем, было ли уже дано согласие (через localStorage для быстрой проверки)
  const consentGiven = localStorage.getItem('cookie_consent');
  
  if (consentGiven === 'true') {
    popup.remove();
    return;
  }
  
  // Показываем попап с небольшой задержкой
  setTimeout(() => {
    popup.classList.add('is-visible');
  }, 500);
  
  // Обработчик клика на кнопку
  acceptButton.addEventListener('click', () => {
    // Сохраняем согласие в localStorage
    localStorage.setItem('cookie_consent', 'true');
    
    // Устанавливаем cookie на 1 год
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `cookie_consent=true; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
    
    // Скрываем попап
    popup.classList.remove('is-visible');
    
    // Удаляем попап из DOM после анимации
    setTimeout(() => {
      popup.remove();
    }, 300);
  });
};

// Инициализация при загрузке DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCookiePopup);
} else {
  initCookiePopup();
}

